import { FormControl, InputLabel, MenuItem, Select, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { DashboardYearFilter } from '../components/DashboardYearFilter';
import { useEnrollmentByAdvisorData } from '../contexts';
import { useDashboardSchoolYear } from '../contexts/DashboardSchoolYearContext';
import { pillToggleGroupStyles } from '../styles/segmentedControlStyles';

export type EnrollmentPeriod = 'year' | 'month';

interface Props {
    period: EnrollmentPeriod;
    onPeriodChange: (period: EnrollmentPeriod) => void;
    month: number | null;
    onMonthChange: (month: number | null) => void;
}

export const EnrollmentByAdvisorControls = ({ period, onPeriodChange, month, onMonthChange }: Props) => {
    const { filter, updateFilter, activeSchoolYear } = useEnrollmentByAdvisorData();
    const { schoolYears } = useDashboardSchoolYear();

    return <DashboardYearFilter
        idPrefix="enrollment-by-advisor"
        years={filter.schoolYears}
        activeSchoolYear={activeSchoolYear}
        availableYears={schoolYears.map(schoolYear => schoolYear.id)}
        onApply={schoolYears => updateFilter({ schoolYears })}
    >
        <ToggleButtonGroup
            value={period}
            exclusive
            size="small"
            aria-label="Enrollment period"
            onChange={(_, value: EnrollmentPeriod | null) => value && onPeriodChange(value)}
            sx={{ ...pillToggleGroupStyles, width: 180 }}
        >
            <ToggleButton value="year">Year</ToggleButton>
            <ToggleButton value="month">Month</ToggleButton>
        </ToggleButtonGroup>
        {period === 'month' && <FormControl size="small" sx={{ minWidth: 180 }}>
            <InputLabel id="enrollment-by-advisor-month-label">Month</InputLabel>
            <Select
                labelId="enrollment-by-advisor-month-label"
                label="Month"
                value={month ?? ''}
                onChange={event => onMonthChange(event.target.value === '' ? null : Number(event.target.value))}
            >
                <MenuItem value="">All Months</MenuItem>
                {Array.from({ length: 12 }, (_, index) => index + 1).map(monthNumber =>
                    <MenuItem key={monthNumber} value={monthNumber}>
                        {new Date(2000, monthNumber - 1).toLocaleString(undefined, { month: 'long' })}
                    </MenuItem>
                )}
            </Select>
        </FormControl>}
    </DashboardYearFilter>;
};
